

























































import { Component, Vue, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import isEmpty from 'lodash/isEmpty'

import { NavigationMenu, Page } from '../../type'
import { ActionSignout } from '../../store/user/types'
import NotificationAlert from './NotificationAlert.vue'
import { COMPANY_SITE_URL } from '../../lib/appHelper'

const UserModule = namespace('user')

@Component({ components: { NotificationAlert } })
export default class Default extends Vue {
  @UserModule.Action('signout') signout!: ActionSignout
  @UserModule.Getter('signedIn') signedIn!: boolean
  @UserModule.Getter('isAdmin') isAdmin!: boolean
  @UserModule.Getter('loading') loading!: boolean
  @Prop({ default: '' }) title!: string
  userDialog = false
  signouted = false

  get menus(): NavigationMenu[] {
    const menus: NavigationMenu[] = []
    if (!this.signedIn && this.$route.name === Page.Home) {
      menus.push({
        action: () => this.$router.push({ name: Page.Signup }),
        text: '法人登録',
        icon: 'mdi-account-plus-outline'
      })
    }
    if (!this.signedIn && this.$route.name !== Page.Signin) {
      menus.push({
        action: () => this.$router.push({ name: Page.Signin }),
        text: '法人サインイン',
        icon: 'mdi-login-variant'
      })
    }
    if (this.signedIn && this.$route.name !== Page.Mypage) {
      menus.push({
        action: () => this.$router.push({ name: Page.Mypage }),
        text: '法人マイページ',
        icon: 'mdi-account-outline'
      })
    }
    if (this.signedIn) {
      menus.push({
        action: this.handleSingout,
        text: '法人サインアウト',
        icon: 'mdi-logout-variant'
      })
    }
    if (this.isAdmin && this.$route.name !== Page.AdminUsers) {
      menus.push({
        action: () => this.$router.push({ name: Page.AdminUsers }),
        text: '法人管理画面',
        icon: 'mdi-tools'
      })
    }
    return menus
  }

  get footerLinks() {
    return [
      {
        title: 'Home',
        action: () => this.$router.push({ name: Page.Home })
      },
      {
        title: '利用規約',
        action: () => this.$router.push({ name: Page.Terms })
      },
      {
        title: '会社概要',
        action: () => {
          location.href = COMPANY_SITE_URL
        }
      }
    ]
  }

  get showMenu() {
    return !isEmpty(this.menus)
  }

  handleSingout() {
    this.signout().then(() => {
      this.signouted = true
      if (this.$route.name !== Page.Home)
        setTimeout(() => this.$router.push({ name: Page.Home }), 1000)
    })
  }
}
